'use client';

import React from 'react';
import { useChangeClientStatusMutation } from '@/app/(main)/client-detail/hooks/useChangeClientStatusMutation';
import { ConfirmModal } from '@/app/components/ConfirmModal';
import ArchiveIcon from '/public/icons/archived.svg';

interface ArchiveClientModalProps {
  isOpen: boolean;
  onClose: () => void;
  isArchived: boolean;
  targetClientId?: number;
  onSuccess?: () => void;
}

export const ArchiveClientModal: React.FC<ArchiveClientModalProps> = ({
  isOpen,
  onClose,
  isArchived,
  targetClientId,
  onSuccess,
}) => {
  const { mutate: changeStatus, isPending } = useChangeClientStatusMutation();

  const handleConfirm = () => {
    changeStatus(
      {
        status: isArchived ? 'ACTIVE' : 'ARCHIVED',
        ...(targetClientId != null ? { targetClientId } : {}),
      },
      {
        onSuccess: () => {
          onSuccess?.();
          onClose();
        },
      }
    );
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={isArchived ? 'Restore client?' : 'Archive client?'}
      description={
        isArchived
          ? 'Are you sure you want to restore this client? The client will be moved back to the active clients list.'
          : 'Are you sure you want to archive this client? Archived clients can be restored later.'
      }
      confirmLabel={isArchived ? 'Restore' : 'Archive'}
      confirmIntent={isArchived ? 'primary' : 'danger'}
      confirmIcon={isArchived ? undefined : <ArchiveIcon className="w-4 h-4" />}
      isPending={isPending}
    />
  );
};
